
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import {RequestPaging} from "@/utils/util";
import {apiVideoDel, apiVideoLists} from '@/api/shop'

@Component({
  components: {
    lsPagination
  }
})
export default class VideoList extends Vue {
  pager: RequestPaging = new RequestPaging();
  searchObj = {};

  async getLists(): Promise<void> {
    this.pager.request({
      callback: apiVideoLists,
      params: {...this.searchObj, type: 1} // type=1表示视频
    });
  }

  async onDelete(row: any): Promise<void> {
    await apiVideoDel({id: row.id});
    this.getLists();
  }

  created() {
    this.getLists();
  }
}
